import React from 'react';
import { useNavigate } from 'react-router-dom';

import AccessDeniedScreen from '@/shared/components/AccessDeniedScreen/AccessDeniedScreen';
import plLabels from '../../constants/plLabels.json';

const labels = plLabels.editFacility.loadErrorScreen;

const EditFacilityLoadErrorScreen: React.FC = () => {
  const navigate = useNavigate();

  return (
    <AccessDeniedScreen
      heading={labels.heading}
      title={labels.title}
      subtitle={labels.subtitle}
      backButtonLabel={labels.backButton}
      onBack={() => navigate('/Placówki')}
    />
  );
};

export default EditFacilityLoadErrorScreen;
